<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="detailDialog"
        persistent
        max-width="600px"
        scrollable
      >
        <v-card style="border-radius: 8px">
          <v-card-title>
            <v-flex
              xs11
              sm11
              md11
            >
              <span class="headline">{{ $t('customer.exportOrderDetailTitle') }}</span>
            </v-flex>
            <v-flex xs1>
              <v-btn
                flat
                icon
                class="close"
                @click="$emit('close')"
              >
                <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span>
              </v-btn>
            </v-flex>
          </v-card-title>

          <v-card-text>
            <div
              v-if="instance.image"
              style="width: 150px; height: 150px; border: 1px solid #ccc; margin-bottom: 10px; border-radius: 6px"
            >
              <a
                :href="`${$_image_path()}${instance.image}`"
                target="_blank"
              >
                <img
                  :src="`${$_image_path()}${instance.image}`"
                  :alt="$t('columns.image')"
                  style="width: 100%; height: 100%; object-fit: contain"
                />
              </a>
            </div>
            <table class="detail-table">
              <tbody>
                <tr>
                  <td class="section-title">{{ $t('customer.orderInfoSection') }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.orderNumber') }}</b></td>
                  <td>{{ instance.order_number }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.customerName') }}</b></td>
                  <td>{{ instance.customer.full_name }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.customerNote') }}</b></td>
                  <td>{{ instance.customer.customer_note }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.customerPhone') }}</b></td>
                  <td>{{ instance.customer.phone_number }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.productName') }}</b></td>
                  <td>{{ instance.product_name }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.quantity') }}</b></td>
                  <td>{{ instance.quantity }}</td>
                </tr>
                <tr v-if="instance.weight">
                  <td><b>{{ $t('columns.weight') }}</b></td>
                  <td>{{ instance.weight }} {{ instance.weight ? instance.weight_unit : '' }}</td>
                </tr>
                <tr v-if="instance.volume_l">
                  <td><b>{{ $t('customer.volumeL') }}</b></td>
                  <td>{{ instance.volume_l }}</td>
                </tr>
                <tr v-if="instance.volume_w">
                  <td><b>{{ $t('customer.volumeW') }}</b></td>
                  <td>{{ instance.volume_w }}</td>
                </tr>
                <tr v-if="instance.volume_h">
                  <td><b>{{ $t('customer.volumeH') }}</b></td>
                  <td>{{ instance.volume_h }}</td>
                </tr>
                <tr>
                  <td colspan="2">&nbsp;</td>
                </tr>
                <tr>
                  <td class="section-title">{{ $t('customer.priceInfoSection') }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.shipping') }}</b></td>
                  <td>{{ instance.shipping | usdFormat }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('customer.internationalTax') }}</b></td>
                  <td>{{ instance.national_tax | usdFormat }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('customer.delivery') }}</b></td>
                  <td>{{ instance.delivery_price | usdFormat }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.discount') }}</b></td>
                  <td>{{ instance.discount | usdFormat }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.price') }}</b></td>
                  <td>{{ instance.price | usdFormat }}</td>
                </tr>
                <tr>
                  <td colspan="2">&nbsp;</td>
                </tr>
                <tr>
                  <td class="section-title">{{ $t('customer.statusInfoSection') }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.status') }}</b></td>
                  <td>
                    <span
                      style="border-radius: 6px; text-transform: capitalize; font-size: 11px"
                      class="label px-2"
                      :class="{
                      'bg-orange-600': instance.status === 1,
                      'bg-indigo-600': instance.status === 2,
                      'bg-danger-600': instance.status === 3,
                      'bg-green-600': instance.status === 4,
                      'bg-primary-600': instance.status === 5,
                      'bg-teal-600': instance.status === 6,
                      'bg-purple-600': instance.status === 7
                    }"
                    >
                      {{ instance.status_text }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><b>{{ $t('customer.orderedAt') }}</b></td>
                  <td>{{ instance.created_at | moment("YYYY-MM-DD hh:mm a") }}</td>
                </tr>
                <tr v-if="instance.canceled_at">
                  <td><b>{{ $t('customer.canceledAt') }}</b></td>
                  <td>{{ instance.canceled_at | moment("YYYY-MM-DD hh:mm a") }}</td>
                </tr>
                <tr v-if="instance.canceled_by">
                  <td><b>{{ $t('customer.canceledBy') }}</b></td>
                  <td>{{ instance.canceled_by ? instance.canceled_by.full_name : '' }}</td>
                </tr>
                <tr v-if="instance.approved_at">
                  <td><b>{{ $t('customer.approvedAt') }}</b></td>
                  <td>{{ instance.approved_at | moment("YYYY-MM-DD hh:mm a") }}</td>
                </tr>
                <tr v-if="instance.approved_by">
                  <td><b>{{ $t('customer.approvedBy') }}</b></td>
                  <td>{{ instance.approved_by ? instance.approved_by.full_name : '' }}</td>
                </tr>
                <tr v-if="instance.sent_at">
                  <td><b>{{ $t('customer.sentAt') }}</b></td>
                  <td>{{ instance.sent_at | moment("YYYY-MM-DD hh:mm a") }}</td>
                </tr>
                <tr v-if="instance.sent_by">
                  <td><b>{{ $t('columns.sentBy') }}</b></td>
                  <td>{{ instance.sent_by ? instance.sent_by.full_name : '' }}</td>
                </tr>
                <tr v-if="instance.received_at">
                  <td><b>{{ $t('customer.receivedAt') }}</b></td>
                  <td>{{ instance.received_at | moment("YYYY-MM-DD hh:mm a") }}</td>
                </tr>
                <tr v-if="instance.received_by">
                  <td><b>{{ $t('customer.receivedBy') }}</b></td>
                  <td>{{ instance.received_by ? instance.received_by.full_name : '' }}</td>
                </tr>
                <tr v-if="instance.status === 7 && instance.last_refund_date">
                  <td><b>{{ $t('customer.refundedAt') }}</b></td>
                  <td>{{ instance.last_refund_date | moment("YYYY-MM-DD hh:mm a") }}</td>
                </tr>
                <tr v-if="instance.status === 7 && instance.refunds && instance.refunds.length > 0">
                  <td><b>{{ $t('customer.refundedBy') }}</b></td>
                  <td>{{ instance.refunds[0].created_by ? instance.refunds[0].created_by.full_name : '' }}</td>
                </tr>
                <tr v-if="instance.is_fully_refunded">
                  <td><b>{{ $t('columns.refundStatus') }}</b></td>
                  <td>
                    <span class="label bg-purple-600" style="border-radius: 6px; font-size: 11px; color: white; padding: 4px 8px;">
                      {{ $t('customer.fullyRefundedBadge') }}
                    </span>
                  </td>
                </tr>
                <tr v-if="instance.total_refunded_amount > 0 && !instance.is_fully_refunded && instance.last_refund_date">
                  <td><b>{{ $t('customer.partiallyRefundedAt') }}</b></td>
                  <td>{{ instance.last_refund_date | moment("YYYY-MM-DD hh:mm a") }}</td>
                </tr>
                <tr v-if="instance.total_refunded_amount > 0 && !instance.is_fully_refunded && instance.refunds && instance.refunds.length > 0">
                  <td><b>{{ $t('customer.partiallyRefundedBy') }}</b></td>
                  <td>{{ instance.refunds[0].created_by ? instance.refunds[0].created_by.full_name : '' }}</td>
                </tr>
                <tr v-if="instance.total_refunded_amount > 0 && !instance.is_fully_refunded">
                  <td><b>{{ $t('columns.refundStatus') }}</b></td>
                  <td>
                    <span class="label bg-orange-600" style="border-radius: 6px; font-size: 11px; color: white; padding: 4px 8px;">
                      {{ $t('finance.statusPartialRefunded') }}
                    </span>
                  </td>
                </tr>
                <tr v-if="instance.total_refunded_amount > 0">
                  <td><b>{{ $t('customer.totalRefundedAmount') }}</b></td>
                  <td>{{ instance.total_refunded_amount | usdFormat }}</td>
                </tr>
                <tr>
                  <td colspan="2">&nbsp;</td>
                </tr>
                <tr>
                  <td class="section-title">{{ $t('customer.receiverInfoSection') }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.name') }}</b></td>
                  <td>{{ instance.receiver_name }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.phone') }}</b></td>
                  <td>{{ instance.receiver_phone }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.email') }}</b></td>
                  <td>{{ instance.receiver_email }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.country') }}</b></td>
                  <td>{{ instance.to_country ? instance.to_country.country_name : '' }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.city') }}</b></td>
                  <td>{{ instance.receiver_city }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('columns.address') }}</b></td>
                  <td>{{ instance.receiver_address }}</td>
                </tr>
                <tr>
                  <td><b>{{ $t('customer.zipCode') }}</b></td>
                  <td>{{ instance.receiver_zip_code }}</td>
                </tr>
              </tbody>
            </table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="height:auto"
              @click="$emit('close')"
              outline
              small
              class="py-1 px-2"
            >
              {{ $t('common.cancel') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'detailDialog',
    'instance'
  ]
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.detail-table .section-title {
  padding-left: 0px;
  padding-top: 0px;
  opacity: 0.7;
}

.detail-table tr td {
  padding: 3px 10px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/exportOrder/viewExportOrderDetails.vue